'use strict'

import type { ChipProps } from '@design/objects/chip/contract'

export const deselect = (element: HTMLElement): void => {
  element.removeAttribute('data-selected')
}

export const select = (element: HTMLElement): void => {
  element.setAttribute('data-selected', 'true')
}

export const disable = (element: HTMLElement): void => {
  element.setAttribute('aria-disabled', 'true')
}

export const enable = (element: HTMLElement): void => {
  element.removeAttribute('aria-disabled')
}

export default function (element: string | HTMLElement, config?: ChipProps): void {
  let el: HTMLElement | string | null = element

  if (typeof element === 'string') {
    el = document.querySelector<HTMLElement>(element)
  }

  if (!el || typeof el === 'string') {
    return
  }

  const isSelectable = el.hasAttribute('data-selectable')

  if (isSelectable) {
    el.addEventListener('click', () => {
      const isSelected = !(el as HTMLElement).hasAttribute('data-selected')

      isSelected ? select(el as HTMLElement) : deselect(el as HTMLElement)
      config && config.onClick && config.onClick(isSelected)
    })
  }
}
